import jump from 'jump.js';

Alpine.data('appeal', (options) => {
	const spotlightModules = [
		'.full-width-media',
		'.text-carousel',
		'.text-parallax-scroll',
	];
	const transition = 1500;
	const formModuleSelector = ['.donation--appeal', '.order-form--appeal'];
	let isLargeScreen = false;
	let formModule;
	let resizeObserver;

	return {
		formExpand: options.formOnly,
		formFocus: options.formOnly,
		spotlightExpand: !options.formOnly,
		spotlightFocus: !options.formOnly,

		init() {
			formModule =
				this.$refs.donation &&
				this.$refs.donation.querySelector(formModuleSelector.join(', '));

			this.listenToBrowserResize();
			this.observeDonationModule();
		},

		listenToBrowserResize() {
			// Media query must match the `md` breakpoint in our stylesheets.
			const mql = window.matchMedia('screen and (min-width: 992px)');

			const handleChange = () => {
				isLargeScreen = mql.matches;
			};

			if (typeof mql.addEventListener === 'function') {
				mql.addEventListener('change', () => {
					handleChange();
				});
			} else if (typeof mql.addListener === 'function') {
				mql.addListener(() => {
					handleChange();
				});
			}

			handleChange();
		},

		throttle(callback, wait) {
			let lastTime = 0;
			return (...args) => {
				const now = new Date();
				if (now - lastTime >= wait) {
					callback(...args);
					lastTime = now;
				}
			};
		},

		observationRequired() {
			return formModule && isLargeScreen;
		},

		observeDonationModule() {
			if (!formModule) return;

			resizeObserver = new ResizeObserver(
				this.throttle(() => {
					if (this.observationRequired()) {
						this.stickSpotlightModule();
					} else {
						this.unstickSpotlightModule();
					}
				}, 100)
			);

			resizeObserver.observe(formModule);
		},

		unobserveDonationModule() {
			if (!resizeObserver) return;
			resizeObserver.disconnect();
		},

		stickSpotlightModule() {
			this.$refs.spotlight.style.minHeight = `${formModule.offsetHeight.toString()}px`;

			const spotlightModule = this.$refs.spotlight.querySelector(
				spotlightModules.join(', ')
			);
			if (!spotlightModule) return;

			spotlightModule.classList.add('appeal-page__sticky-module');
		},

		unstickSpotlightModule() {
			this.$refs.spotlight.style.minHeight = '';

			const spotlightModule = this.$refs.spotlight.querySelector(
				spotlightModules.join(', ')
			);
			if (!spotlightModule) return;

			spotlightModule.classList.remove('appeal-page__sticky-module');
		},

		collapseSpotlight() {
			if (isLargeScreen) return;

			const spotlightWrapper =
				this.$refs.spotlight && this.$refs.spotlight.parentNode;

			spotlightWrapper.classList.add('appeal-page__spotlight--collapsing');
			spotlightWrapper.style.height = `${spotlightWrapper.scrollHeight}px`;

			setTimeout(() => {
				spotlightWrapper.style.height = '0';

				setTimeout(() => {
					spotlightWrapper.classList.add('appeal-page__spotlight--collapsed');
					spotlightWrapper.classList.remove(
						'appeal-page__spotlight--collapsing'
					);
					spotlightWrapper.style.height = '';
				}, transition);
			});
		},

		expandSpotlight() {
			const spotlightWrapper =
				this.$refs.spotlight && this.$refs.spotlight.parentNode;

			spotlightWrapper.classList.remove('appeal-page__spotlight--collapsed');
			spotlightWrapper.classList.add('appeal-page__spotlight--collapsing');
			spotlightWrapper.style.height = isLargeScreen
				? `${window.innerHeight}px`
				: '0';

			setTimeout(() => {
				spotlightWrapper.style.height = `${window.innerHeight}px`;

				setTimeout(() => {
					spotlightWrapper.classList.remove(
						'appeal-page__spotlight--collapsing'
					);
					spotlightWrapper.style.height = '';
				}, transition);
			});
		},

		goToAppealForm() {
			const path = window.location.pathname;
			const isAppealPage = path.indexOf('/appeal/') === 0;

			jump(this.$refs.donation, {
				duration: 500,
				offset: isAppealPage ? 0 : -80,
			});
		},

		appealFormFocus() {
			this.unobserveDonationModule();

			this.formFocus = true;

			this.$nextTick(() => {
				this.collapseSpotlight();

				jump(this.$root, {
					duration: isLargeScreen ? transition : transition / 2,
					a11y: true,
				});
			});

			setTimeout(() => {
				this.formExpand = true;

				if (this.observationRequired()) {
					this.unstickSpotlightModule();
				}
			}, transition);
		},

		appealSpotlightFocus() {
			this.formExpand = false;

			this.$nextTick(() => {
				this.formFocus = false;

				if (this.observationRequired()) {
					this.stickSpotlightModule();
				}

				jump(this.$root, {
					duration: transition,
					a11y: true,
				});

				this.$nextTick(() => {
					this.expandSpotlight();
				});
			});

			setTimeout(() => {
				this.observeDonationModule();
			}, transition);
		},
	};
});
